import dayjs from 'dayjs'
import { newAppealState } from 'feature/appeals/redux/appealFormCreateSelector'
import { useState } from 'react'
import {
  Controller,
  FieldValues,
  FormProvider,
  SubmitHandler,
  useForm,
} from 'react-hook-form'
import { useAppSelector } from 'store/hooks'
import { TextField } from 'ui'

import {
  OrderManageFromHeader,
  OrderManageFromFooter,
  OrderManageFormDateTime,
} from '../OrderManageFromUi'

import style from './OrderManageDateForm.module.scss'
type TMainOrderManage = {
  handleBack: () => void
  title: string
  description: string
  subtitle?: string
  onSubmit: SubmitHandler<FieldValues>
  isLoading: boolean
}

//  форма переноса даты заявки

export function OrderManageDateForm({
  handleBack,
  title,
  subtitle,
  description,
  isLoading,
  onSubmit,
}: TMainOrderManage) {
  const { uid } = useAppSelector(newAppealState)
  const [isDateValid, setDateValid] = useState<boolean>(false)
  const [isTimeValid, setTimeValid] = useState<boolean>(false)

  const methods = useForm({
    defaultValues: {
      comment: '',
      date: null,
      time: null,
      uid: uid,
    },
    mode: 'onChange',
  })
  const { handleSubmit, control, setValue, setError, clearErrors } = methods

  const today = dayjs()

  const handlePickerChange = (newDate: Date) => {
    if (dayjs(newDate) < today || newDate === null) {
      setDateValid(false)
      setError('date', {})
      return
    }
    //@ts-ignore
    setValue('date', newDate)

    clearErrors('date')
    setDateValid(true)
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleTimeFieldChange = (...time: any[]) => {
    if (time[0] === null || !!time[1]?.validationError?.length) {
      setTimeValid(false)
      setError('time', {})
      return
    }

    clearErrors('time')
    setValue('time', time[0])
    setTimeValid(true)
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} className={style.orderManageForm}>
        <div>
          <OrderManageFromHeader
            title={title}
            subtitle={subtitle}
            description={description}
          />

          <div className={style.dateWrapper}>
            <OrderManageFormDateTime
              handleTimeFieldChange={handleTimeFieldChange}
              handlePickerChange={handlePickerChange}
            />
          </div>

          <Controller
            name='comment'
            control={control}
            render={({ field }) => (
              <TextField
                multiline
                minRows={4}
                maxRows={10}
                inputProps={{ maxLength: 1000, autoComplete: 'off' }}
                label='Комментарий'
                className={style.reasonFiled}
                {...field}
              />
            )}
          />
          <Controller
            name='uid'
            defaultValue={uid}
            control={control}
            render={({ field }) => (
              <TextField type='hidden' className={style.hidden} {...field} />
            )}
          />
        </div>

        <OrderManageFromFooter
          isButtonDisabled={!isTimeValid || !isDateValid || isLoading}
          isLoading={isLoading}
          handleBack={handleBack}
        />
      </form>
    </FormProvider>
  )
}
